import { render, staticRenderFns } from "./TabDeal.vue?vue&type=template&id=aecc8172"
import script from "./TabDeal.vue?vue&type=script&lang=js"
export * from "./TabDeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports